module.exports = __webpack_public_path__ + "static/media/subscribe.825a297c.svg";